import { CompatibilityFormData } from '@js/interfaces';
import React from 'react';
import { UseFormRegister } from 'react-hook-form';

type Props = {
  questionItem: {
    category_id: number,
    category_name: string,
    category_answer_type: string,
    option_ids: number[],
    option_names: string[]
  },
  register: UseFormRegister<CompatibilityFormData>
  errors: { [name: string]: object | undefined }
};

export const CategoryAnswerType = (props: Props) => {
  const {questionItem, register, errors} = props;
  return (
    <>
      {questionItem.category_answer_type === 'single' && (
        <>
          {questionItem.option_names.map((option, index) =>
            <div className="form-column" key={index}>
              <div className="form-radio">
                <label className="form-radio__label" htmlFor={`category_option_${questionItem.category_id}_${questionItem.option_ids[index]}`}>
                  <input
                    {...register(`category_option_${questionItem.category_id}`, {required: `${questionItem.category_name}は必ず選択して下さい`})}
                    type="radio"
                    value={`${questionItem.option_ids[index]}`}
                    className={`form-radio__input ${errors[`category_option_${questionItem.category_id}`] && 'is-error'}`}
                    id={`category_option_${questionItem.category_id}_${questionItem.option_ids[index]}`}
                  />
                  <span className="form-radio__text">{option}</span>
                </label>
              </div>
            </div>
          )}
        </>
      )}
      {questionItem.category_answer_type === 'multiple' && (
        <>
          {questionItem.option_names.map((option, index) => {
            return (
              <div className="form-column" key={index}>
                <div className="form-checkbox">
                  <label className="form-checkbox__label">
                    <input
                      {...register(`category_option_${questionItem.category_id}`, {required: `${questionItem.category_name}は必ず選択して下さい`})}
                      type="checkbox"
                      value={`${questionItem.option_ids[index]}`}
                      className={`form-checkbox__input ${errors[`category_option_${questionItem.category_id}`] && 'is-error'}`}
                    />
                    <span className="form-checkbox__text">{option}</span>
                  </label>
                </div>
              </div>
            );
          })}
        </>
      )}
      {questionItem.category_answer_type === 'text' && (
        <input
          {...register(`category_option_${questionItem.category_id}`, {required: `${questionItem.category_name}は必ず入力して下さい`})}
          type="text"
          className={`form-input ${errors[`category_option_${questionItem.category_id}`] && 'is-error'}`}
          id={`category_option_${questionItem.category_id}`}
        />
      )}
    </>
  );
};
